/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.47 2.152a1 1 0 0 1 1.06 0l8 5a1.054 1.054 0 0 1 .114.082.995.995 0 0 1 .22.258l.018.035a.765.765 0 0 1 .033.066l.013.032c.01.025.02.051.028.078l.008.027a.768.768 0 0 1 .018.08l.007.041A.992.992 0 0 1 21 8l-.004-.086.003.053L21 8v8a1 1 0 0 1-.47.848l-8 5a1.067 1.067 0 0 1-.123.066l-.037.015a.761.761 0 0 1-.066.025l-.035.01a.664.664 0 0 1-.065.016l-.026.005a.915.915 0 0 1-.168.017h-.02a.975.975 0 0 1-.167-.016l-.028-.006a.66.66 0 0 1-.064-.015l-.035-.012a.696.696 0 0 1-.066-.023l-.037-.016a.978.978 0 0 1-.123-.066l.076.043a1.022 1.022 0 0 1-.062-.035l-.014-.008-8-5A1 1 0 0 1 3 16V8a1.066 1.066 0 0 1 .01-.15l.008-.04a.83.83 0 0 1 .018-.08l.008-.027a.767.767 0 0 1 .027-.079l.014-.031a.726.726 0 0 1 .032-.066l.02-.035a.985.985 0 0 1 .333-.34l-.083.058a1.02 1.02 0 0 1 .072-.05l.011-.008zM5 9.803v5.643l6 3.75v-5.643zm14 0-6 3.75v5.643l6-3.75zm-7-5.625L5.885 8 12 11.821 18.114 8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBox as Box };
